import { DatePicker } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { DateRangeEnd, useDayPickerStrings } from '../enums';
import { format } from 'date-fns';
import { IDateState } from '../types';

/**
 * "Exact date" option that shows the user a FluentUI DatePicker.
 */
export const FullDateSelector = ({
  date,
  setDate,
  dateRangeEnd,
}: IDateState & {
  /** Not currently used. */
  dateRangeEnd?: DateRangeEnd;
}) => {
  const [t] = useTranslation('search');
  const strings = useDayPickerStrings(t);

  const label = t('Specific day', {
    ns: 'search',
    defaultValue: 'Specific day',
  });

  return (
    <DatePicker
      {...{
        label,
        value: date,
        onSelectDate: d => setDate(d || undefined),
        autoCorrect: 'No',
        strings,
        formatDate,
        allowTextInput: true,
      }}
    />
  );
};

const formatDate = (date: Date | undefined) => {
  if (!date) {
    return '';
  }

  return format(date, 'PP');
};
